import Axios from "axios";
import Cookies from "js-cookie";

const getCurrentPort = () => {
  if (typeof window !== 'undefined') {
    return window.location.port || '80';
  }
  return '5003';
};
const port = process.env.NODE_ENV === 'production' ? getCurrentPort() : '443';
const host = typeof window !== 'undefined' ? window.location.hostname : 'http://10.10.11.32';
export const baseURL = `https://dashboard.ras.iq/api/`;
export const baseURLFlat = `https://dashboard.ras.iq`;

export const imageUrl = `https://dashboard.ras.iq`;

let navigator = null;
export const setNavigator = (nav) => {
  navigator = nav;
};
const base = Axios.create({
  baseURL: baseURL,
});

const loginPath = "/authentication/sign-in";

base.interceptors.response.use(
  (response) => response,
   (error) => {
    if (error.response && error.response.status === 401 && error.response.data?.message.indexOf("Please login again")>-1) {
      console.log("Unauthorized Middleware");
      // window.location.replace("/authentication/sign-in");
      Cookies.remove("Authentication");
      Cookies.remove("userTypeName");
      Cookies.remove("displayName");
      // window.location = "/authentication/sign-in";

      if (window.location.pathname !== loginPath) {
        window.location = loginPath;
      }

    }
    return Promise.reject(error);
  }
);

base.interceptors.request.use(
  function (config) {
    const Authentication = Cookies.get("Authentication");
    if (Authentication === undefined) {
      if (window.location.pathname !== loginPath) {
        window.location = loginPath;
      }    }

    if (Authentication) {
      config.headers.Authorization = `Bearer ${Authentication}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

function trimStringsInObject(obj) {
  if (typeof obj === 'string') {
    return obj.trim();
  } else if (Array.isArray(obj)) {
    return obj.map(trimStringsInObject);
  } else if (obj && typeof obj === 'object') {
    const trimmed = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        trimmed[key] = trimStringsInObject(obj[key]);
      }
    }
    return trimmed;
  }
  return obj;
}


function jsonToFormData(jsonObject) {
  const formData = new FormData();

  const appendFormData = (data, parentKey = "") => {
    if (data instanceof File) {
      // Directly append File objects
      formData.append(parentKey, data);
    } else if (data && typeof data === "object" && !Array.isArray(data)) {
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          appendFormData(data[key], parentKey ? `${parentKey}[${key}]` : key);
        }
      }
    } else if (Array.isArray(data)) {
      data.forEach((item, index) => {
        appendFormData(item, `${parentKey}[${index}]`);
      });
    } else {
      formData.append(parentKey, data);
    }
  };

  appendFormData(jsonObject);
  return formData;
}

export const RequestService = {
  get: (url, params = {}) => {
    return base.get(url, { params });
  },
  post: (url, data) => {
    const trimmedData = trimStringsInObject(data);
    return base.post(url, trimmedData);
  },
  put: (url, data) => {
    const trimmedData = trimStringsInObject(data);
    return base.put(url, trimmedData);
  },
  delete: (url) => {
    return base.delete(url);
  },

  putFormData: (url, data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
  
    return base.put(url, formData, {});
  },

  postFormData: (url, data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        if (Array.isArray(data[key])) {
          // Handle arrays (like file lists)
          data[key].forEach((item, index) => {
            if (item instanceof File) {
              formData.append(`${key}[${index}]`, item);
            } else {
              formData.append(`${key}[${index}]`, item);
            }
          });
        } else if (data[key] instanceof File) {
          // Handle single files
          formData.append(key, data[key]);
        } else {
          // Handle regular data
          formData.append(key, data[key]);
        }
      }
    });
  
    return base.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  loadImage: async (imageUrl) => {
    try {
      const fullImageUrl = `${imageUrl}`;
      const response = await Axios.get(fullImageUrl, {
        baseURL: imageUrl,
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${Cookies.get("Authentication")}`
        }
      });
      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error('Error loading image:', error);
      throw error;
    }
  },

  downloadFile: async (fileUrl) => {
    try {
      const response = await Axios.get(`${baseURLFlat}${fileUrl}`, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${Cookies.get("Authentication")}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    }
  },
};